import { IAccountMappingSubFLI, SortedMappingItem } from '@modeso/types__aumico-lib-annualreport-be';
import { GatheringItems } from '../GatheringVisitor';

export class SortedItem {
    constructor(public sortedItem: SortedMappingItem | IAccountMappingSubFLI) {}

    accept(visitor: GatheringItems) {
        visitor.visitSortedItems(this.sortedItem);
    }
}
